import L from "leaflet";
import { ContentContainer } from "components/ui/display/ContentContainer";
import { Input } from "components/ui/inputs/Input";
import styled, { useTheme } from "styled-components";
import { MapContainer, Marker, WMSTileLayer, GeoJSON, Pane } from "react-leaflet";
import { useEffect, useState } from "react";
import MapMarkerIcon from 'assets/icons/map_marker.svg';
import { SwitchRow } from "components/ui/controls/SwitchRow";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";


export const ProjectMap = ({content, handler}) => {
    return (
        <StyledProjectMap>
            <div className="projectMapWrapper">
                <div className="optionsContainer">
                    <div className="moduleHeader">
                        <span>
                            Geografisk plassering
                        </span>
                        Klikk på kartet for å angi prosjektets lokasjon.
                    </div>

                    <ContentContainer contentOrientation="column" contentGap="lg" padding='lg'>
                        <span className="locationInfoHeader">Stedsinformasjon</span>
                        <Input
                            prefix={<MaterialIcon name='center_focus_weak' weight={300}/>}
                            title='Koordinater' disabled
                            value={content.position ? content.position.lat.toFixed(4) + " °N, " + content.position.lng.toFixed(4) + " °Ø" : ''}
                        />
                        <Input
                            prefix={<MaterialIcon name='account_balance' weight={300}/>}
                            title='Kommune' disabled
                            value={content.municipality ? content.municipality : ''}
                        />
                        <Input
                            prefix={<MaterialIcon name='explore' weight={300}/>}
                            title='Fylke' disabled
                            value={content.county ? content.county : ''}
                        />
                        <Input
                            prefix={<MaterialIcon name='activity_zone' weight={300}/>}
                            title='NTM sone' disabled
                            value={content.ntmZone ? "Sone " + content.ntmZone : ''}
                        />
                    </ContentContainer>
                    <SwitchRow
                        icon={<MaterialIcon name='dashboard' weight={300}/>}
                        title="Vis på dashboard"
                        description="Vises på kartet på hovedsiden."
                        isChecked={content.displayOnDashboard}
                        onChange={(e) => handler(prev => ({...prev, displayOnDashboard: e.target.checked}))}
                        
                    />
                </div>
                <div className="mapContainer">
                    <LeafletMap
                        position={content.position}
                        editMarker={(e, feature) => {

                            const municipalityName = feature.properties.kommunenavn;

                            const countyNumber = feature.properties.kommunenummer.substring(0, 2);
                            let countyName = '';

                            switch(countyNumber)
                            {
                                case '03': countyName = "Oslo"; break;
                                case '11': countyName = "Rogaland"; break;
                                case '15': countyName = "Møre og Romsdal"; break;
                                case '18': countyName = "Nordland"; break;
                                case '31': countyName = "Østføld"; break;
                                case '32': countyName = "Akerhus"; break;
                                case '33': countyName = "Buskerud"; break;
                                case '34': countyName = "Innlandet"; break;
                                case '39': countyName = "Vestfold"; break;
                                case '40': countyName = "Telemark"; break;
                                case '42': countyName = "Agder"; break;
                                case '46': countyName = "Vestland"; break;
                                case '50': countyName = "Trøndelag"; break;
                                case '55': countyName = "Troms"; break;
                                case '56': countyName = "Finnmark"; break;
                                default: countyName = 'Ukjent';
                            }

                            let NTMZone = Math.floor(e.latlng.lng);
                            if(NTMZone < 5) NTMZone = 5;
                            else if(NTMZone > 30) NTMZone = 30;

                            handler?.(prev => ({...prev, position: {lat: e.latlng.lat, lng: e.latlng.lng}, county: countyName, municipality: municipalityName, ntmZone: NTMZone}));
                        }}
                    />
                </div>
            </div>
            
        </StyledProjectMap>
    )
}

const StyledProjectMap = styled.div`

    height: 100%;
    width: 100%;

    div.projectMapWrapper
    {
        display: flex;
        gap: ${({theme}) => theme.spacing.lg};

        div.optionsContainer
        {
            flex: 1;
            min-width: 400px;
            display: flex;
            flex-direction: column;
            gap: ${({theme}) => theme.spacing.lg};

            div.moduleHeader
            {
                span
                {
                    display: block;
                    font-weight: 600;
                    font-size: ${({theme}) => theme.fontSize.lg};
                    margin-bottom: ${({theme}) => theme.spacing.sm};
                    color: ${({theme}) => theme.colors.neutralSecondaryForeground};
                }

                color: ${({theme}) => theme.colors.mutedForeground};
            }

            span.locationInfoHeader
            {
                font-weight: 600;
            }
        }
        div.mapContainer
        {
            border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            flex: 2;
            min-height: 400px;
            overflow: hidden;
            border-radius: ${({theme}) => theme.cornerRadius.md};
        }
    }
`

const customIcon = new L.Icon({
    iconUrl: MapMarkerIcon,
    iconSize: [36, 50],
    iconAnchor: [18, 45]
})

const LeafletMap = ({position, editMarker}) => {
    const fallbackCenter = [60.198856, 8.130057];
    const fallbackZoom = 6;

    const GlobalTheme = useTheme();
    const [geoJSON, setGeoJSON] = useState(null);

    useEffect(() => {
        fetch('/kommuner.geojson').then(res => res.json()).then(setGeoJSON);
    }, []);

    return (
        <MapContainer
            attributionControl={false}
            style={{ height: "100%", width: "100%"}}
            center={position ? [position.lat, position.lng] : fallbackCenter }
            zoom={fallbackZoom}
        >
            <WMSTileLayer
                url="https://wms.geonorge.no/skwms1/wms.topograatone"
                layers="topograatone"
                format="image/png"
                transparent={false}
                attribution="Kartverket / Geonorge"
            />
            <Pane name="geojson-pane" style={{ zIndex: 200 }} />

            {
                position ? 
                <Marker
                    icon={customIcon}
                    position={position}
                    
                />
            : null
            }
            

            {geoJSON ? <GeoJSON
                pane="geojson-pane"
                data={geoJSON}
                style={{
                    illColor: '#000000',
                    fillOpacity: 0.0,
                    color: '#090909',
                    weight: 1,
                    opacity: 0.05
                }}
                onEachFeature={(feature, layer) => {
                    layer.on({

                        click: (e) => {
                            if(e.originalEvent._stopped) return;
                            editMarker(e, feature);
                        },

                        mouseover: (e) => {
                            e.target.setStyle({
                            weight: 2,
                            color: GlobalTheme.colors.neutralSecondaryForeground,
                            opacity: 0.65
                            });
                        },

                        mouseout: (e) => {
                            e.target.setStyle({
                                fillColor: GlobalTheme.colors.black,
                                color: '#090909',
                                opacity: 0.05,
                                weight: 1,
                            });
                        }
                    });

                }}
            /> : null}

        </MapContainer>
    )
}   
